import { IShop} from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

const tagType = 'Shops';

export const shopApi = crudEndpointsFactory<IShop>()('shops', 'Shops').injectEndpoints({
  endpoints: (builder) => ({
    connectToHubrise: builder.mutation<{ authorizationUrl: string }, { shopId: string }>({
      query: (body) => ({
        url: 'shops/hubrise',
        method: 'POST',
        body,
      }),
    }),
    disconnectHubrise: builder.mutation<IShop, { shopId: string }>({
      query: (body) => ({
        url: 'shops/hubrise-disconnect',
        method: 'POST',
        body,
      }),
    }),
    updateHubriseMenusHoraires: builder.mutation<IShop, { shopId: string; menusHorairesPlateformes: boolean }>({
      query: ({ shopId, menusHorairesPlateformes }) => ({
        url: `shops/${shopId}/hubrise-config`,
        method: 'PATCH',
        body: { menusHorairesPlateformes },
      }),
      invalidatesTags: ['Shops'],
    }),
  }),
});
